import { apiClientes } from "../config/api";
import { Response } from "../interfaces/services/Response";
import { TokenSmsProps, TokenEmailProps } from "../interfaces/props/passwordRecovery/TokenProps";
import { getTokenClientes } from "../Store/storages/AuthenticationStorage";


export type TokenServiceProps = {
  [index: number | string]: {
    send: (payload: any) => Promise<Response | null>,
    helper: string,
    resendText: string,
    sendText: string
  },

}

export const sendTokenSMSRegistroBeneficiario = async (payload: any): Promise<Response | null> => {
  try {
    const response = await apiClientes.post('/Token/SendTokenSMSRegistroBeneficiario', payload);
    return response;

  } catch (error: any) {
    const errorData = error?.response
    return errorData
  }
}

export const sendTokenEmailRegistroBeneficiario = async (payload: any): Promise<Response | null> => {
  try {
    const response = await apiClientes.post('/Token/SendTokenEmailRegistroBeneficiario', payload)
    return response;

  } catch (error: any) {
    const errorData = error?.response
    return errorData
  }
}


export const sendTokenRegistroBeneficiario = async (payload: TokenSmsProps | TokenEmailProps): Promise<Response | null> => {

  const type: any = { 1: 'Email', 2: 'SMS' }

  try {
    const response = await apiClientes.post(`/Token/SendToken${type[payload.tipoToken]}RegistroBeneficiario`, payload);

    return response;

  } catch (error: any) {
    const errorData = error?.response
    return errorData
  }
}

const TokenService: TokenServiceProps = {
  1: {
    send: sendTokenRegistroBeneficiario,
    helper: 'Enviamos o Token ao e-mail cadastrado, basta digitá-lo antes de expirar, no campo a seguir e continuar. Ele tem validade de 3 horas e 59 minutos minutos.',
    resendText: 'REENVIAR TOKEN POR EMAIL',
    sendText: 'RECEBER TOKEN POR EMAIL'
  },
  2: {
    send: sendTokenRegistroBeneficiario,
    helper: 'Enviamos o Token via SMS ao número de celular cadastrado, basta digitá-lo antes de expirar, no campo a seguir e continuar. Ele tem validade de 3 horas e 59 minutos minutos.',
    resendText: 'REENVIAR TOKEN POR SMS',
    sendText: 'RECEBER TOKEN POR SMS'
  },

}

export const getTokenNavegacaoClipf = async (pagina: string): Promise<string | null> => {
  try {
    const response = await apiClientes.get('/token/gettokennavegacaoclipf', {
      params: { pagina },
      headers: { Authorization: `Bearer ${await getTokenClientes()}` }
    });
    return response.data;
  } catch (error) {
    console.log({ error });
    return null;
  }
};

export const getTokenNavegacaoTranscricao = async (): Promise<string | null> => {
  try {
    const response = await apiClientes.get('/login/gettokennavegacaotranscricao', {
      headers: { Authorization: `Bearer ${await getTokenClientes()}` }
    });
    return response.data;
  } catch (error) {
    console.log({ error });
    return null;
  }
};

export const getTokenMeusDispositivos = async (): Promise<string | null> => {
  try {
    const response = await apiClientes.get('/clausularestri/geturlmeusdispositivos', {
      headers: { Authorization: `Bearer ${await getTokenClientes()}` }
    });
    return response.data;
  } catch (error) {
    console.log({ error });
    return null;
  }
};

export const getTokenProgramaOstomia = async (): Promise<string | null> => {
  try {
    const response = await apiClientes.get('/clausularestri/geturlostomia', {
      headers: { Authorization: `Bearer ${await getTokenClientes()}` }
    });
    return response.data;
  } catch (error) {
    console.log({ error });
    return null;
  }
};

export default TokenService;
